<template>
	<div>
		<div class="index-main">
			<!-- 左侧菜单栏 -->
			<div class="left">
				<div class="shou-suo" @click="toggleCollapsed">
					<img v-if="!collapsed" src="@/assets/images/layout/shou_suo.png" alt="" />
					<img v-else src="@/assets/images/layout/show_men.png" alt="" />
				</div>

				<div class="logo">
					<div>
						<img src="@/assets/images/logo/home-logo.png" alt="" />
					</div>
					<div class="desc" v-show="!collapsed">{{ $t("home.title") }}</div>
				</div>
				<a-menu
					style="min-height: calc(100vh - 118px); border-radius: 0px 0px 30px 0px;"
					:default-selected-keys="[this.$route.meta.parentName]"
					:default-open-keys="['sub1']"
					mode="inline"
					theme="dark"
					:inline-collapsed="collapsed"
				>
					<!-- 遍历路由表 homeRoutes -->
					<a-menu-item v-for="item in homeRoutes[0]['children']" :key="item.meta.parentName" @click="(val) => clickMenu(val, item)">
						<router-link :to="homeRoutes[0].path + '/' + item.path" style="color: #fff; display: flex; align-items: center">
							<a-icon :type="item.meta.icon ? item.meta.icon : 'appstore'" />
							<!-- <span>{{ item.meta.title }}</span> -->
							<span>{{ $t(`home.route_menus.${item.meta.field}`) }}</span>
						</router-link>
					</a-menu-item>
				</a-menu>
			</div>
			<div class="conent">
				<Head />
				<div style="overflow: auto; height: calc(100vh - 70px)">
					<div class="router-view">
						<!-- 路由正文部分 -->
						<router-view :getSecondMenus="getSecondMenus" :key="$route.fullPath"></router-view>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部 -->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Head from "./components/Head";
import { commonAPI } from "@/apis";
import config from "@/config";
import {
	isAuthErrorMessage,
	clearAuthStateAndRedirect,
	tryRestoreRememberMeSession,
} from "@/utils/authSession";

// 导入路由对象
import homeRoutes from "@/router/routes/home.routes";
export default {
	name: "indexLayout",
	components: { Head },

	created() {
		this.validateSession();
	},

	data() {
		return {
			// 路由对象
			homeRoutes: homeRoutes,
			collapsed: false,
		};
	},
	computed: {
		...mapGetters("auth", ["token", "user"]),
		//  获取当前父级路由
		getSecondMenus() {
			if (this.$route.meta.menuLevel === 2) {
				return homeRoutes[0]["children"].find((one) => one.name == this.$route.meta.parentName) || {};
			}

			return {};
		},
	},

	methods: {
		// 会话过期：先尝试 7 天免登录恢复，再跳转登录（保留 REMEMBER_ME）
		async validateSession() {
			const isUnauthorized = (res) => {
				const code = res.code != null ? res.code : res.status;
				const msg = res.msg || res.message || "";
				return (
					code == config.SERVICES.RESPONSE_CODE.UNAUTHORIZED ||
					isAuthErrorMessage(msg)
				);
			};

			let res = await commonAPI.getAction("/config/profile/get");
			if (isUnauthorized(res)) {
				tryRestoreRememberMeSession(this.$cookies);
				res = await commonAPI.getAction("/config/profile/get");
			}
			if (isUnauthorized(res)) {
				clearAuthStateAndRedirect({ preserveRememberMe: true });
			}
		},
		// 伸缩事件
		toggleCollapsed() {
			this.collapsed = !this.collapsed;
		},

		clickMenu(val, item) {
			console.log("点击菜单的值", val, item);
		},
	},
};
</script>

<style lang="less" scoped>
.index-main {
	display: flex;
	height: 100vh;
	.left {
		height: 100%;
		position: relative;
		background-color: #040849;
		.shou-suo {
			position: absolute;
			right: -10px;
			top: 48px;
			cursor: pointer;
		}
		::v-deep .ant-menu {
			transition: none;
			background-color: transparent;
		}
		::v-deep {
			.ant-menu-item-selected {
				border-bottom: 0;
				background-color: transparent;
				background-image: url("~@/assets/images/myapp/myapp_bg.png") !important;
				background-repeat: no-repeat;
				background-position: center center;
				background-size: 100% 100%;
				height: 90px;
				line-height: 90px;
			}
			.ant-menu-item-selected .anticon {
				color: #000c17 !important;
			}
			.ant-menu-item-selected .anticon + span {
				color: #000c17;
			}
		}

		.logo {
			text-align: center;
			padding-top: 20px;
			padding-bottom: 20px;
			height: 118px;
			border-radius: 0px 30px 0px 0px;
			.desc {
				margin-top: 10px;
				color: #ffffff;
				font-size: 16px;
				padding: 0 10px;
			}
		}
	}
	.conent {
		flex: 1;
		padding-left: 18px;
		.router-view {
			padding: 25px 33px;
			background-color: #ffffff;
			box-shadow: 0px 3px 9px 0px rgba(48, 82, 163, 0.07);
			border-radius: 25px;
		}
	}
}
</style>
